module.exports = __webpack_public_path__ + "static/media/John C. Frémont - 1856.d9dc6fdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/John C. Frémont - 1856.jpg
// module id = 518
// module chunks = 0